import { format, formatDistanceStrict } from "date-fns";
import { enUS as en, ru, de, es, fr } from "date-fns/locale";

const locales = { en, ru, de, es, fr };

const currentLanguageFromStore = () => {
    const language = localStorage.getItem("currentLanguage");
    return language === "ru-RU" ? "ru" : language === "en-US" ? "en" : language
}

export const formatDateByLanguage = (value: Date, dateFormat: string) => {
    return format(value, dateFormat, { locale: locales[currentLanguageFromStore() as keyof typeof locales] })
}

export const formatDistanceByDate = (date: number, baseDate = Date.now()) => {
    return formatDistanceStrict(baseDate, date * 1000, {
        locale: locales[currentLanguageFromStore() as keyof typeof locales]
    })
}
